import { Controller } from "@hotwired/stimulus"
import { trackWebEvent } from "../src/web_analytics"

// Declaratively emits anonymous web events. Two modes, both optional:
//
// 1. On click — attach with data-action="click->web-analytics#track" and supply
//    the event name and any extra properties via Stimulus params, e.g.
//      data-web-analytics-name-param="app_redirect_click"
//      data-web-analytics-store-param="ios"
//
// 2. On render (a passive impression) — set an impression value on the element,
//    e.g. data-web-analytics-impression-value="match_teaser_impression". Like
//    every web event it is buffered and only persists once the session engages
//    (see web_analytics.js), so bot/prerender impressions are dropped.
export default class extends Controller {
  static values = { impression: String, surface: String }

  connect() {
    if (this.impressionValue) {
      trackWebEvent(this.impressionValue, { path: window.location.pathname, surface: this.surfaceValue })
    }
  }

  track(event) {
    const { name, ...rest } = event.params
    if (!name) return

    trackWebEvent(name, { path: window.location.pathname, ...rest })
  }
}
